import * as i0 from "@angular/core";
export class AutoDropDirectionModule {
}
AutoDropDirectionModule.ɵfac = function AutoDropDirectionModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AutoDropDirectionModule)(); };
AutoDropDirectionModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AutoDropDirectionModule });
AutoDropDirectionModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
